import { forwardRef, useImperativeHandle } from 'react';

import { VFlex } from '../VFlex';
import { VStack } from '../VStack';
import VFileBrowserContentList from './VFileBrowserContentList';
import VFileBrowserEventListener from './VFileBrowserEventListener';
import { VFileBrowserTreeBoundary } from './VFileBrowserTreeBoundary';
import {
  // VFileBrowserContentDragboxContextProvider,
  VFileBrowserContextProvider,
  VFileBrowserScrollContextProvider,
  useFileBrowserContext,
} from './context';
import style from './style';
import type { VFileBrowserProps, VFileBrowserRef } from './type';

const VFileBrowser = forwardRef<
  VFileBrowserRef,
  VFileBrowserProps<Record<string, any>>
>((props, ref) => {
  return (
    <VFileBrowserContextProvider {...props}>
      <VFileBrowserInner ref={ref} {...props} />
    </VFileBrowserContextProvider>
  );
});

const VFileBrowserInner = forwardRef<
  VFileBrowserRef,
  VFileBrowserProps<Record<string, any>>
>((_, ref) => {
  const {
    itemByUuid,
    itemList,
    setChildren,
    setCurrentDirUuid,
    currentDir,
    currentDirUuid,
  } = useFileBrowserContext();

  useImperativeHandle(
    ref,
    () => ({
      itemByUuid,
      itemList,
      setChildren,
      setCurrentDirUuid,
      currentDir,
      currentDirUuid,
    }),
    [
      itemByUuid,
      itemList,
      setChildren,
      setCurrentDirUuid,
      currentDir,
      currentDirUuid,
    ],
  );

  return (
    <VFileBrowserEventListener>
      <VStack
        className={style.vFileBrowserContainer}
        data-testid="v-file-browser-container"
      >
        <VFlex
          className="flex-1 overflow-hidden"
          data-testid="v-file-browser-wrapper"
        >
          <VFileBrowserScrollContextProvider>
            <VFileBrowserTreeBoundary />
          </VFileBrowserScrollContextProvider>

          <VStack
            className="w-full overflow-x-auto"
            data-testid="v-file-browser-content-wrapper"
          >
            {/* <VFileBrowserContentDragboxContextProvider> */}
            <VFileBrowserContentList />
            {/* </VFileBrowserContentDragboxContextProvider> */}
          </VStack>
        </VFlex>
      </VStack>
    </VFileBrowserEventListener>
  );
});

VFileBrowser.displayName = 'VFileBrowser';
VFileBrowserInner.displayName = 'VFileBrowserInner';

export default VFileBrowser;
